<template>
    <Fragment>
        <div id="app" :class="app.isSpinnerVisible && !app.isSpinnerAlwaysVisible
                ? 'cover-spin'
                : ''
            ">
            <div class="app-container" :class="Unex.Layout.containerClass">
                <div class="d-flex flex-column justify-content-center">
                    <!-- NAVEGACIO v1-->
                    <div class="d-none d-lg-block" v-if="app.webVersion == '1'">
                        <!-- BREADCRUMB - FIL DARIADNA-->
                        <navigationbarComponent v-if="app.showNavigationBar"
                            :infoNavigationbar="app.navigationbarElements" class="mb-2"></navigationbarComponent>
                    </div>

                    <!-- NAVEGACIO v2-->
                    <!-- <div class="d-flex justify-content-end mt-2 mb-3" v-if="app.webVersion == '2'">
                        <span class="d-none d-md-block unex-button" @click="app.routerPush('myConfigs')">
                            {{ $t('nav_titel_my_configs') }}
                        </span>
                    </div> -->
                    <div class="mb-4" v-if="app.webVersion == '2'">
                        <navigationbarV2Component v-if="app.showNavigationBar"
                                :infoNavigationbar="app.navigationbarElements" class="mb-2"></navigationbarV2Component>
                    </div>

                    <!-- ---------------------------- -->
                    <!--  DESKTOP I MOBIL -->
                    <!-- ---------------------------- -->
                    <div class="content_app text-center" :class="app.isSpinnerAlwaysVisible &&
                            (app.currentConfiguration.stage === '3' ||
                                app.currentConfiguration.stage === '2')
                            ? 'routerWhileSpinner'
                            : ''
                        ">
                        <router-view :key="$route.fullPath"></router-view>
                    </div>

                    <!-- NAVEGACIO v2-->
                    <template  v-if="app.webVersion == '2'">
                        <div v-if="!this.app.WholeSaler.isWholeSaler || app.auth.isLogged" class="d-flex d-md-none justify-content-center mt-2 mb-3">
                            <span class="unex-button" @click="app.routerPush('myConfigs')">
                                {{ $t('nav_titel_my_configs') }}
                            </span>
                        </div>
                    </template>

                    <!-- MODAL -->
                    <modalComponent ref="modalComponent" :infoModal="infoModal"></modalComponent>
                </div>
            </div>

            <!-- <link
                rel="stylesheet"
                href="https://use.fontawesome.com/releases/v5.8.1/css/all.css"
                integrity="sha384-50oBUHEmvpQ+1lW4y57PTFmhCaXp0ML5d60M1M7uH2+nqUivzIebhndOJK28anvf"
                crossorigin="anonymous"
            /> -->

            <!-- SPINNER -->
            <div :class="app.isSpinnerVisible || app.isSpinnerAlwaysVisible
                    ? 'spin'
                    : 'hidespin'
                ">
                <div class="spinner-border text-danger" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import { app } from "./application.js";
//import configuratorsComponent from './components/configurator/configurators.vue'
import navigationbarComponent from "./components/navigationbar.vue";
import navigationbarV2Component from "./components/navigationbarV2.vue";
import navigationbarWithLoginComponent from "./components/navigationbarWithLogin.vue";
import navigationbarMobileComponent from "./components/navigationbarMobile.vue";

import modalComponent from "./components/modal.vue";
import developBarComponent from "./components/developBar.vue";
import userComponent from "@/components/user/user.vue";

export default {
    name: "app",
    data() {
        return {
            app,
            window: { width: 0, height: 0 },
            componentKey: 0,
            Unex: Unex,
            infoModal: {
                type: Object,
                default: () => ({
                    message: "Modal del App.vue mensaje del modal",
                    title: "titulo del modal",
                    textConfirmationButton: "Guardar cambios",
                }),
            },
        };
    },
    methods: {
        setModalProp: function (infoModal) {
            //this.$refs.modalComponent.open = true;
            this.infoModal = infoModal;
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
    },

    created() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },

    mounted() {
        //s'assigna aqui el modalshowModalComponent perque els $refs només està disponible un cop fet el mounted
        this.app.modalComponent = this.$refs.modalComponent;
    },

    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },

    components: {
        Fragment,
        navigationbarComponent,
        navigationbarV2Component,
        developBarComponent,
        modalComponent,
        navigationbarWithLoginComponent,
        navigationbarMobileComponent,
        userComponent
    }
};
</script>

<style lang="scss">
@import "../node_modules/bootstrap/scss/bootstrap.scss";
@import "../node_modules/tablesaw/dist/tablesaw.css";

// font-family: "Avenir", Helvetica, Arial, sans-serif;
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    position: relative; //es posiciona el element pq fills absolut posicionin respecte ell
    max-width: 1070px; //es fixa max-amplada web desktop
    // padding:50px;
    margin: auto;
    padding-bottom: 50px;
}

@media (max-width: 576px) {
    .app-container {
        margin-left: 0 !important;
        margin-right: 0 !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
}

.routerWhileSpinner {
    min-height: 700px;
    //display: none;
    visibility: hidden;
}

.btn:active,
.btn:focus,
.btn:focus:active {
    outline: 0 !important;
    box-shadow: none !important;
}

.btn_primary {
    color: red !important;
    border-color: red !important;
}

.btn_primary:hover {
    background-color: rgb(255, 166, 166) !important;
}

.color_primary {
    color: red !important;
}

.cover-spin {
    opacity: 0.7;
    //filter: blur(1px);
    z-index: 998;
    width: 100%;
    height: 100%;
}

.spin {
    opacity: 1;
    background-color: #ffffff;
    position: fixed;
    left: 48%;
    top: 48%;
    display: block;
}

.hidespin {
    display: none;
}

.content_app {
    min-height: 400px;
    margin-bottom: 100px;
}

.login_button {
    font-size: 26px;
    line-height: 30px;
    height: 30px;
    font-weight: 300;
    color: #f0614e;
    cursor: pointer;
}

//hide outline inputs
.form-control:focus {
    border-color: black !important;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 4px rgba(0, 0, 0, 0.6) !important;
}

//hide arrows up down inputs
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}

.vue-lb-container {
    background-color: rgba(0, 0, 0, .95) !important;
}
</style>
